var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'randomizer-popup',
    ("randomizer-popup__valign-" + _vm.popUpValign),
    {'randomizer-popup__top': _vm.top0}
  ]},[_c('VueCustomScrollbar',{staticClass:"scroll-area"},[_c(_vm.popUpComponent,{tag:"div",staticClass:"randomizer-popup_content"})],1),(_vm.popUpCanClose)?_c('button',{staticClass:"dialog_close",on:{"click":function($event){return _vm.$root.$emit('closeRandomRewardsPopUp')}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }